export default "__VITE_ASSET__DXtcVqQH__"